// src/components/Students.js
import React from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { showModal } from '../redux/actions/ModalActions';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Pagination from '../utils/Pagination';
import { handleItemsPerPageChange, handlePageChange } from '../utils/PaginationUtilities';

export default function Students({ 
    peoples, 
    totalData, 
    currentPage, 
    itemsPerPage, 
    status, 
    selectedStudents, 
    handleCheckboxChange = () => {},  
    changeStatusStudent = () => {}, 
    batchId 
}) {
    const dispatch = useDispatch();
    const userRole = sessionStorage.getItem("userRole");



    return (
        <div className="container">
             
            <div className="row">
                
                
                {peoples?.length > 0 ? (
                    peoples?.map((el, index) => 
                        el.students?.map((student, studentIndex) => (
                            <div className="col-sm-12 text-capitalize" key={`${el?._id}-${student?.studentId?._id}`}>
                                <div className="d-flex justify-content-between">
                                    <div>
                                        <h5 className="fs-6 my-0">
                                            {status && userRole == 2 && (
                                                <input 
                                                    type="checkbox"
                                                    checked={selectedStudents?.includes(student?.studentId?._id)}
                                                    className="form-check-input me-2"
                                                    onChange={() => handleCheckboxChange(student?.studentId?._id)} 
                                                />
                                            )}
                                            {student?.studentId?.name}
                                        </h5>
                                        <span className="email">{student?.studentId?.email}</span>
                                    </div>
                                    <div className="dropdown">
                                        <IconButton 
                                            type="button" 
                                            data-bs-toggle="dropdown" 
                                            aria-expanded="false"
                                        >
                                            <MoreVertIcon />
                                        </IconButton>
                                        <ul className="dropdown-menu">
                                            {userRole == 2 &&
                                                <li>
                                                    <a 
                                                        className="dropdown-item" 
                                                        href="#" 
                                                        onClick={() => changeStatusStudent(el?._id, student?.studentId?._id, student?.studentstatus)}
                                                    >
                                                        {status ? "Remove" : "Add Back"}
                                                    </a>
                                                </li>
                                            }
                                            <li>
                                                {userRole==2 ? ( 
                                                    <Link 
                                                    to={`/trainer/graph/${batchId}/${student?.studentId?._id}`} 
                                                    className="dropdown-item"
                                                >
                                                    View
                                                </Link>
                                                   
                                                ):(<>
                                                <Link 
                                                    to={`/admin/graph/${batchId}/${student?.studentId?._id}`} 
                                                    className="dropdown-item"
                                                >
                                                    View
                                                </Link>
                                                </>)}
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <hr className="my-1" />
                            </div>
                        ))
                    )
                ) : (
                    <h1>No Student Present!!</h1>
                )}
            </div>
            <div className="d-flex justify-content-end">
                <Pagination
                    count={totalData}
                    page={currentPage}
                    itemsPerPage={itemsPerPage}
                    onPageChange={handlePageChange}
                    onItemsPerPageChange={handleItemsPerPageChange}
                />
            </div>
        </div>
    );
}
